import React, { useEffect, useState } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import Navbar from '../navbar/navbar.component';
import logo from './abs-logo-white.png';
import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { configService, getAuthToken, UserService } from '../../service';

const Header = () => {
    const navigate = useNavigate();
    const isAuthenticted = useIsAuthenticated();
    const { instance, accounts } = useMsal();
    const [currentUser, setCurrentUser] = useState();

    useEffect(() => {
        (async () => {
            if (isAuthenticted) await getCurrentUser();
        })();
    }, [isAuthenticted]);

    const getCurrentUser = async () => {
        const authToken = await getAuthToken(instance, accounts[0]);
        const user = await UserService.getCurrentUser(authToken);

        if (!user) {
            return;
        }

        setCurrentUser(user);
    };

    const getBrandName = () => {
        const brandName = 'Office Map';
        if (configService.appConfig.environmentName === 'Production') return brandName;

        return `${brandName} - ${configService.appConfig.environmentName}`;
    };

    const handleLogout = () => {
        instance.logoutRedirect();
    };

    return (
        <Navbar
            brandName={getBrandName()}
            type="main"
            brandImg={logo}
            onBrandClick={() => ''}
            onMenuItemClick={() => ''}
            menuOptions={[
                {
                    text: (
                        <>
                            <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                <AuthenticatedTemplate>
                                    <Stack direction={'column'} spacing={0} alignItems={'flex-end'}>
                                        <div>{currentUser && <>{`${currentUser.LastName}, ${currentUser.FirstName}`}</>}</div>
                                        <div>{currentUser && <>{`${currentUser.Email}`}</>}</div>
                                    </Stack>

                                    <Button
                                        style={{
                                            backgroundColor: '#DA1F33'
                                        }}
                                        variant="contained"
                                        onClick={() => navigate('/admin')}
                                    >
                                        Admin
                                    </Button>

                                    <Button
                                        style={{
                                            backgroundColor: '#DA1F33'
                                        }}
                                        variant="contained"
                                        onClick={() => handleLogout()}
                                    >
                                        Logout
                                    </Button>
                                </AuthenticatedTemplate>
                                <UnauthenticatedTemplate>
                                    <Button
                                        style={{
                                            backgroundColor: '#DA1F33'
                                        }}
                                        variant="contained"
                                        onClick={() => navigate('/admin')}
                                    >
                                        Login
                                    </Button>
                                </UnauthenticatedTemplate>
                            </Stack>
                        </>
                    ),
                    position: 'right'
                }
            ]}
        />
    );
};

export default Header;
